export default function calculateIssueId(issue) {
  return `${issue.id}_${issue.reasonIndex}`;
}
